import styles from './Sitemap.module.scss'

export interface SitemapUrl {
  loc: string
}

export interface SitemapData {
  category: string
  pages: SitemapUrl[]
}

interface SitemapProps {
  data: SitemapData[]
}

const Sitemap = ({ data }: SitemapProps) => (
  <div className={styles.container}>
    <h1 className={styles.title}>Sitemap</h1>
    <div className={styles.divider} />

    {data?.length > 0 &&
      data.map(({ category, pages }) => (
        <div key={category} className={styles.categorySection}>
          <h2 className={styles.categoryTitle}>{category}</h2>
          <ul className={styles.list}>
            {pages.map((page, index) => (
              <li key={index}>
                <a href={page.loc}>{page.loc}</a>
              </li>
            ))}
          </ul>
        </div>
      ))}
  </div>
)

export default Sitemap
